import * as React from 'react'
import { useState, useEffect } from 'react'
import styled from '../../../common/src/components/styled'
import { FetchAgentVirtualTourQuery } from '../../../common/src/types.gen'
import DailyFrame from './DailyFrame'
import Greeting from './Greeting'
import NextVirtualAppointmentInfo from './NextVirtualAppointmentInfo'
import TimeDate from './TimeDate'

const Root = styled.div({
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  justifyContent: 'space-evenly',
})

interface AgentVirtualTourProps {
  virtualTour: NonNullable<FetchAgentVirtualTourQuery['agentVirtualTour']>
}

const AgentVirtualTour = (props: AgentVirtualTourProps) => {
  const { virtualTour } = props
  const { contact, dailyCallOptions, calendarLink, showing } = virtualTour

  const [now, setNow] = useState(new Date())

  useEffect(() => {
    const clockUpdateIntervalInMilliseconds = 1000
    const interval = setInterval(() => {
      setNow(new Date())
    }, clockUpdateIntervalInMilliseconds)
    return () => clearInterval(interval)
  }, [])

  if (dailyCallOptions == null) {
    return (
      <Root>
        <TimeDate now={now} />
        <Greeting now={now} agentFirstName={contact.firstName} />
        <NextVirtualAppointmentInfo now={now} calendarLink={calendarLink} showing={showing} />
      </Root>
    )
  }

  return <DailyFrame dailyCallOptions={dailyCallOptions} />
}

export default AgentVirtualTour
